const storageKey = 'office:poy-report:expanded:v1'

// Keep only the current tab's bill IDs, never report amounts or detail payloads.
const createPoyExpansionState = () => {
  let storage
  let mayRestore = false
  let currentScope = null
  let expandedIds = null
  try {
    storage = window.sessionStorage
    mayRestore = window.performance?.getEntriesByType?.('navigation')?.[0]?.type === 'reload'
  } catch (error) { /* Storage may be unavailable; the report still works. */ }

  const remove = () => {
    try { if (storage) storage.removeItem(storageKey) } catch (error) { /* Optional UI state. */ }
  }
  const clear = () => {
    currentScope = null
    expandedIds = null
    mayRestore = false
    remove()
  }

  return Object.freeze({
    read(scope) {
      if (!scope) { clear(); return null }
      if (scope === currentScope) return expandedIds
      currentScope = scope
      expandedIds = null
      if (mayRestore) {
        try {
          const saved = JSON.parse(storage?.getItem(storageKey) || 'null')
          if (saved?.scope === scope && Array.isArray(saved.ids) && saved.ids.length <= 100
            && saved.ids.every(id => typeof id === 'string' && id.length > 0 && id.length <= 256)) {
            expandedIds = [...new Set(saved.ids)]
          }
        } catch (error) { /* Ignore stale or malformed UI state. */ }
      }
      // Only a reload may restore a saved scope. A new query always starts clean.
      mayRestore = false
      if (expandedIds === null) remove()
      return expandedIds
    },
    write(scope, ids) {
      if (!scope) { clear(); return }
      currentScope = scope
      expandedIds = [...new Set(ids)]
      mayRestore = false
      try {
        if (storage) storage.setItem(storageKey, JSON.stringify({ scope, ids: expandedIds }))
      } catch (error) { /* Quota/privacy restrictions must not block interaction. */ }
    },
    clear,
  })
}

export default createPoyExpansionState
